export default __webpack_public_path__ + "static/media/parkingrampe8.d941f340.jpg";